//import './upload.scss'
import { Title } from '@ui/components/title'
import { Button } from '@ui/components/button'
import { type MobileState } from '@store/mobile-reducer.ts'
//import { UploadBox } from '@ui/components/upload-box/upload-box.component.tsx'
//import { useUpload } from '@ui/pages/mobile-upload/components/upload/upload.hooks.ts'
//import { Loader } from '@ui/components/loader'
import { useMobileContext } from '@hooks/use-mobile-context.ts'
import { scrollToTop } from '@utils/iframe'
import { useUpload } from './upload.hooks'
import { UploadBox } from '@ui/components/upload-box'

const BoxError: React.FC<{
	show: boolean
	title: string
	description: string
}> = ({ show, title, description }) => {
	if (show) {
		return (
			<div className={'upload__error'}>
				<p className='upload__error--title'>Errore</p>
				<p>
					{title}: {description}
				</p>
			</div>
		)
	}

	return null
}

type UploadComponentProps = {
	id: keyof MobileState['steps']
	dynamicFields?: boolean
}
const UploadComponent: React.FC<UploadComponentProps> = ({
	id,
	dynamicFields,
}) => {
	const { state } = useMobileContext()
	const shouldTriggerOCR = state.steps[id].ocrScan && state.shouldUseOCR

	const {
		data: { isValid, boxes, showLoader, OCRError },
		actions: { setMobileUpload, deleteMobileUpload, uploadPhotos, moveTo },
	} = useUpload(id, shouldTriggerOCR, dynamicFields)

	if (showLoader) {
		return (
			<div className='upload'>
				<div className={'upload__loader'}>
					{/* <Loader force={true} /> */}
				</div>
			</div>
		)
	}

	return (
		<div className={'upload'}>
			<Title small>Fotografa o allega il documento</Title>
			<p className={'upload__desc'}>
				Fotografa il documento in un ambiente luminoso assicurandoti che i dati
				siano ben visibili o allegalo se già salvato sul tuo smartphone.
			</p>
			<div className={'upload__boxes'}>
				{Object.keys(boxes).map((box, idx) => (
					<UploadBox
						id={id}
						index={idx + 1}
						side={box}
						onSuccess={setMobileUpload}
						onDelete={deleteMobileUpload}
						showID={!dynamicFields}
					/>
				))}
			</div>
			<BoxError
				show={OCRError.type !== 'NONE'}
				title={OCRError.title}
				description={OCRError.description}
			/>

			<p className={'upload__desc'}>
				Puoi allegare file formato JPG, PNG, TIFF, HEIC/HEIF o PDF di dimensioni
				non superiori a 5MB.
			</p>
			<section className='upload__footer'>
				<Button
					label={'PROCEDI'}
					className={'upload__next'}
					disabled={!isValid}
					onClick={uploadPhotos}
				/>
				<p
					className={'upload__back'}
					onClick={() => {
						scrollToTop()
						moveTo('SELEZIONE')
					}}
				>
					Torna indietro
				</p>
			</section>
		</div>
	)
}

export { UploadComponent }
